import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
